import { IAddSocialMediaBulkResponseRow } from "@shared/lib/types/influencer";
import { Button } from "@shared/ui";
import { Error } from "@shared/ui/icons";
import { ArrowRight, CheckCircle, Instagram, Youtube } from "lucide-react";
import styles from "./review.module.scss";

interface SingleCreatorReviewProps {
  handle: string;
  successData: IAddSocialMediaBulkResponseRow[];
  isSuggesting: boolean;
  onClose: () => void;
  onImport: () => void;
}

export function SingleCreatorReview({
  handle,
  successData,
  isSuggesting,
  onClose,
  onImport,
}: SingleCreatorReviewProps) {
  const validCount = successData.filter((row) => row.status === "success")
    .length;

  return (
    <>
      <div className={styles.reviewHeader}>
        <div className={styles.successBanner}>
          <CheckCircle size={18} className={styles.successIcon} />
          <span className={styles.successText}>
            Creator "{handle}" processed successfully
          </span>
          <span className={styles.successBadge}>{validCount} Valid</span>
        </div>
      </div>
      <div className={styles.reviewBody}>
        <div className={styles.reviewTable}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>Handle</th>
                <th>Platform</th>
                <th className={styles.statusHeader}>Status</th>
              </tr>
            </thead>
            <tbody>
              {successData.map((row, idx) => (
                <tr
                  key={idx}
                  className={row.status === "failed" ? styles.errorRow : ""}
                >
                  <td className={styles.handleCell}>{handle}</td>
                  <td className={styles.platformCell}>
                    <div className={styles.platformDisplay}>
                      {row.platform === "instagram" && (
                        <Instagram size={14} className={styles.igIcon} />
                      )}
                      {row.platform === "youtube" && (
                        <Youtube size={14} className={styles.ytIcon} />
                      )}
                      <span className={styles.platformText}>
                        {row.status === "success" ? row.platform : "Invalid"}
                      </span>
                    </div>
                  </td>
                  <td className={styles.statusCell}>
                    {row.status === "success" ? (
                      <span className={styles.readyStatus}>Ready</span>
                    ) : (
                      <div className={styles.errorStatus}>
                        <Error size={14} />
                        <span>Invalid</span>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className={styles.modalFooter}>
        <Button onClick={onClose} type="text" className={styles.cancelButton}>
          Cancel
        </Button>
        <Button
          onClick={onImport}
          disabled={isSuggesting || validCount === 0}
          loading={isSuggesting}
          type="primary"
          className={styles.importButton}
          icon={<ArrowRight size={14} />}
          iconPosition="end"
        >
          Import {validCount} Creator{validCount !== 1 ? "s" : ""}
        </Button>
      </div>
    </>
  );
}
